// item 3a: в Safari при блокировке кук / ITP / приватном режиме ОБРАЩЕНИЕ к
// localStorage|sessionStorage бросает SecurityError. Раньше хранилища доставались на
// уровне модуля (`const storageTypes = { session: sessionStorage, local: localStorage }`),
// поэтому исключение падало ещё при инициализации бандла — приложение не рендерилось
// вовсе (белый экран при открытии инвайт-ссылки из WhatsApp). Теперь доступ ленивый,
// обёрнут в try/catch и при недоступности деградирует на in-memory хранилище:
// данные не переживут перезагрузку, но приложение работает.
const memoryFallback = { local: new Map(), session: new Map() };
const resolved = {}; // кэш: тип -> Storage | null (null = недоступно, используем память)

function getStorage(type) {
  if (type in resolved) return resolved[type];
  let storage = null;
  try {
    const candidate = type === "session" ? sessionStorage : localStorage;
    // Safari может пустить на чтение, но бросить на записи — проверяем полный цикл
    const probeKey = "__wpp_storage_probe__";
    candidate.setItem(probeKey, "1");
    candidate.removeItem(probeKey);
    storage = candidate;
  } catch (e) {
    storage = null;
  }
  resolved[type] = storage;
  return storage;
}

export default function useBrowserStorage() {
  const setItem = (key, item, type = "local") => {
    const value = JSON.stringify(item);
    const storage = getStorage(type);
    if (!storage) {
      memoryFallback[type].set(key, value);
      return;
    }
    try {
      storage.setItem(key, value);
    } catch (e) {
      // квота/приватный режим — не роняем вызывающий код
      memoryFallback[type].set(key, value);
    }
  };

  const getItem = (key, type = "local") => {
    const storage = getStorage(type);
    let raw;
    try {
      raw = storage
        ? storage.getItem(key)
        : memoryFallback[type].get(key) ?? null;
    } catch (e) {
      raw = memoryFallback[type].get(key) ?? null;
    }
    if (raw === "undefined") {
      removeItem(key, type);
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch (e) {
      // битое значение не должно ронять страницу
      return null;
    }
  };

  const removeItem = (key, type = "local") => {
    memoryFallback[type].delete(key);
    const storage = getStorage(type);
    if (!storage) return;
    try {
      storage.removeItem(key);
    } catch (e) {
      // игнорируем — значение уже удалено из памяти
    }
  };

  return { setItem, getItem, removeItem };
}
